import { Record } from 'immutable';
export class PhoneNumberPropertyMetadata extends Record({
  extension: null,
  phoneNumber: null,
  phoneNumberType: null,
  possibleNumber: false,
  regionCode: null,
  state: null,
  usnumber: false,
  validNumber: false,
  wasRegionInferred: false,
  wasParseResultEquivalentWithNoInference: null
}, 'PhoneNumberPropertyMetadata') {
  // The response from this can be passed to twilio to dial a number + extension
  get toNumberString() {
    const extension = this.get('extension');
    const phoneNumber = this.get('phoneNumber');
    return extension ? `${phoneNumber} ext ${extension}` : phoneNumber;
  }
}
export class PhoneNumberPropertyRecord extends Record({
  propertyName: null,
  label: null,
  hubspotDefined: false,
  value: null,
  metadata: new PhoneNumberPropertyMetadata()
}, 'PhoneNumberProperty') {
  constructor(attributes = {}) {
    super(Object.assign({}, attributes, {
      metadata: new PhoneNumberPropertyMetadata(
      // this property comes from the BE as validatedPhoneNumber
      // to avoid confusion we assign it to metadata here
      attributes.validatedPhoneNumber || attributes.metadata || {})
    }));
  }
}